import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { convertLegacyEntityContentExtension } from '@backstage/plugin-catalog-react/alpha';
import {
  EntityAwsSecurityHubContent,
  isAwsSecurithHubFindingsAvailable, // upstream typo ("Securith") — verified against the pinned package's own .d.ts, not ours to fix
} from '@aws/aws-securityhub-plugin-for-backstage';

/**
 * AWS Security Hub entity content — a full tab (heaviest AWS Labs bridge:
 * a findings list, not a small overview card), gated on the same legacy
 * bridge as aws-ecs — see that module's header comment and
 * docs/operations.md → "AWS Labs plugin suite".
 *
 * Requires the entity to carry `aws.amazon.com/aws-securityhub-findings-tags`
 * AND Security Hub to actually be enabled in the AWS account/region —
 * neither is true anywhere in AGM's catalog yet, so this tab won't appear
 * on any entity until both exist. The optional AI remediation-assistant
 * hook this plugin supports is NOT enabled — that pulls in the whole genai
 * stack (see docs/plugins/deferred/aws-genai.md), which is its own
 * unconfigured, cost-gated decision this wave.
 */
const awsSecurityHubEntityContent = convertLegacyEntityContentExtension(
  EntityAwsSecurityHubContent,
  {
    name: 'aws-securityhub',
    filter: isAwsSecurithHubFindingsAvailable,
    path: '/security-hub',
    title: 'Security Hub',
  },
);

export const awsSecurityHubModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [awsSecurityHubEntityContent],
});
